// extracted by mini-css-extract-plugin
module.exports = {"selectClient__filters":"styles_selectClient__filters__2BLwm","selectClient__clients":"styles_selectClient__clients__2Ok-r"};